import React from "react";

import { SvgWrapper } from "../styles";

interface SvgComponentProps {
  height: number;
  width: number;
  color: string;
}

export const IconMaterial = (props: SvgComponentProps) => {
  const { width, height, color } = props;

  return (
    <SvgWrapper>
      <svg
        width={width}
        height={height}
        viewBox={`0 0 ${width} ${height}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.99991 11.0834C9.89158 11.0834 9.78324 11.0584 9.68324 11.0001L2.32492 6.74177C2.02492 6.56677 1.9249 6.18341 2.0999 5.88341C2.2749 5.58341 2.6499 5.48339 2.95823 5.65839L9.99991 9.73341L16.9999 5.68342C17.2999 5.50842 17.6832 5.61677 17.8582 5.90843C18.0332 6.20843 17.9249 6.59174 17.6332 6.76674L10.3249 11.0001C10.2166 11.0501 10.1082 11.0834 9.99991 11.0834Z"
          fill={color}
        />
        <path
          d="M10 18.6335C9.65837 18.6335 9.37504 18.3501 9.37504 18.0085V10.4501C9.37504 10.1084 9.65837 9.82511 10 9.82511C10.3417 9.82511 10.625 10.1084 10.625 10.4501V18.0085C10.625 18.3501 10.3417 18.6335 10 18.6335Z"
          fill={color}
        />
        <path
          d="M10.0001 18.9584C9.26681 18.9584 8.54181 18.8001 7.96681 18.4834L3.51681 16.0084C2.30848 15.3418 1.36682 13.7334 1.36682 12.3501V7.64173C1.36682 6.25839 2.30848 4.65843 3.51681 3.98343L7.96681 1.51675C9.10847 0.883415 10.8918 0.883415 12.0335 1.51675L16.4835 3.99172C17.6918 4.65839 18.6335 6.26674 18.6335 7.65007V12.3584C18.6335 13.7418 17.6918 15.3417 16.4835 16.0167L12.0335 18.4834C11.4585 18.8001 10.7335 18.9584 10.0001 18.9584ZM10.0001 2.29174C9.47514 2.29174 8.95848 2.40008 8.57515 2.60841L4.12515 5.08339C3.32515 5.53339 2.61682 6.72507 2.61682 7.65007V12.3584C2.61682 13.2751 3.32515 14.4751 4.12515 14.9251L8.57515 17.4001C9.33348 17.8251 10.6668 17.8251 11.4251 17.4001L15.8751 14.9251C16.6751 14.4751 17.3835 13.2834 17.3835 12.3584V7.65007C17.3835 6.7334 16.6751 5.53339 15.8751 5.08339L11.4251 2.60841C11.0418 2.40008 10.5251 2.29174 10.0001 2.29174Z"
          fill={color}
        />
        <path
          d="M14.1669 11.6585C13.8252 11.6585 13.5419 11.3751 13.5419 11.0335V8.35015L5.94186 3.9668C5.64186 3.7918 5.54184 3.40845 5.71684 3.11679C5.89184 2.81679 6.26686 2.71677 6.56686 2.89177L14.4752 7.45847C14.6669 7.56681 14.7919 7.77511 14.7919 8.00011V11.0501C14.7919 11.3751 14.5085 11.6585 14.1669 11.6585Z"
          fill={color}
        />
      </svg>
    </SvgWrapper>
  );
};
